import { useApi, configApiRef } from '@backstage/core-plugin-api';

const useIsPodDeleteEnabled = () => {
  const configApi = useApi(configApiRef);
  return configApi.getOptionalConfig("kubernetes.frontend")?.getOptionalBoolean("podDelete.enabled");
};

export { useIsPodDeleteEnabled };
//# sourceMappingURL=useIsPodDeleteEnabled.esm.js.map
